import * as TYPES from './medical-notes-actiontypes';

export const medicalNotesLoadedSuccess = (notes, userPreferenceDateFilter) => ({
  type: TYPES.MEDICAL_NOTES_LOADED_SUCCESS,
  notes,
  userPreferenceDateFilter,
});

export const newMedicalNotesCountLoadedSuccess = (count) => ({
  type: TYPES.MEDICAL_NOTES_COUNT_LOADED_SUCCESS,
  isNotReviewedByPatientCount: count,
});

export const setMedicalNoteReviewedSuccess = (medicalNoteId) => ({
  type: TYPES.MEDICAL_NOTE_SET_REVIEWED_SUCCESS,
  selectedMedicalNoteId: medicalNoteId,
});

export const selectedMedicalNoteChanged = (selectedMedicalNoteId) => (
  {
    type: TYPES.MEDICAL_NOTES_SELECTED_CHANGED,
    selectedMedicalNoteId,
  }
);

export const medicalNotesFilterOptionsChanged = (filter) => ({
  type: TYPES.MEDICAL_NOTES_FILTER_OPTIONS_CHANGED,
  filter,
});

export const toggleFilterPanel = (showFilterPanel) => ({
  type: TYPES.MEDICAL_NOTES_TOGGLE_FILTER_PANEL,
  showFilterPanel,
});

export const setTotalNumberOfPages = (totalNumberOfPages) => ({
  type: TYPES.MEDICAL_NOTES_SET_TOTAL_NUMBER_OF_PAGES,
  totalNumberOfPages,
});

export const setCurrentPageNumber = (currentPageNumber) => ({
  type: TYPES.MEDICAL_NOTES_SET_CURRENT_PAGE_NUMBER,
  currentPageNumber,
});

export const setCurrentPageUrl = (currentPageUrl) => ({
  type: TYPES.MEDICAL_NOTES_SET_CURRENT_PAGE_URL,
  currentPageUrl,
});